import React from 'react';

const CdIcon = class extends React.Component {
	render() {
		return (
			<svg fill="currentColor" stroke="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" style={this.props.style||{}}>
				<path d="M16.707,15.29346a.999.999,0,0,1,0,1.41357,1.00051,1.00051,0,0,1-1.41406-.00049A.99972.99972,0,0,1,16.707,15.293Zm7.77832,9.19189a12.0001,12.0001,0,1,1,0-16.9707A11.96127,11.96127,0,0,1,24.48535,24.48535Zm-12.02051-12.021a4.99072,4.99072,0,0,1,1.58686-1.06818L11.81805,6.929a9.81725,9.81725,0,0,0-4.88946,4.88885l4.473,2.23651A4.96449,4.96449,0,0,1,12.46484,12.46436Zm12.60657,7.71777-4.473-2.23651a4.94938,4.94938,0,0,1-2.65009,2.6582l2.23346,4.46686a9.8145,9.8145,0,0,0,4.88965-4.88855ZM19,16a3,3,0,1,0-3,3A3,3,0,0,0,19,16Z"/>
			</svg>
		);
	}
}

export default CdIcon;
